export const base = 0
export const mapToolWrapper = 1
export const mapControlDisabler = 2
export const mapLayerControl = 100
export const mapOverlay = 101
export const mapControlIcon = 110
export const mapTypeToggle = 110
export const mapMessage = 210
export const appMenu = 200
export const insightsPage = 300
export const insightsMapHeader = 310
export const sidebar = 400
export const sidebarContent = 410
export const googleSearchBackdrop = 500
export const googleSearchPanel = 510
export const overlay = 600
export const overlayContent = 610
export const overlayContentMenu = 620
export const overlayContentAlert = 630
export const popper = 1500
export const adminPanel = 2000

export const navigationComponents = 1000
export const modal = 9999
